/* Keep the custom header in sync with confirmed native and VESSARIQ cart updates. */
(() => {
  'use strict';
  if (window.vqCartCountBound) return;
  window.vqCartCountBound = true;
  let revision = 0;
  const update = count => {
    if (typeof count !== 'number' || !Number.isInteger(count) || count < 0) return false;
    document.querySelectorAll('[data-vq-cart-count]').forEach(node => {
      const value = String(count);
      if (node.textContent !== value) node.textContent = value;
    });
    return true;
  };
  const refresh = async current => {
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
        credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store',
      });
      if (!response.ok) return;
      const cart = await response.json();
      if (current === revision) update(cart.item_count);
    } catch { /* Keep the last confirmed count when a read fails. */ }
  };
  document.addEventListener('vq:cart-updated', event => {
    const current = ++revision;
    if (!update(event.detail?.cart?.item_count)) refresh(current);
  });
  // This is Shopify's standard cart event, also used by the native cart icon.
  // Listen directly so the custom header does not depend on an inline module import.
  document.addEventListener('shopify:cart:lines-update', async event => {
    const current = ++revision;
    try {
      const result = await event.promise;
      if (current !== revision) return;
      if (!update(result?.cart?.totalQuantity ?? result?.detail?.itemCount)) await refresh(current);
    } catch { if (current === revision) await refresh(current); }
  });
  window.addEventListener('pageshow', event => {
    if (event.persisted) refresh(++revision);
  });
  // Reconcile the initial count when the page HTML came from a cache.
  refresh(++revision);
})();
